import { loadingFadeOut } from "virtual:app-loading";
import { setupLayouts } from "virtual:generated-layouts";
import {
  createWebHistory,
  type NavigationGuardNext,
  type RouteLocationNormalized,
} from "vue-router";
import { handleHotUpdate, routes } from "vue-router/auto-routes";
import { createRouter as _createRouter } from "vue-i18n-routing";
import i18n from "@/locales";
import Cookies from "js-cookie";
import { I18N_COOKIE_KEY } from "@/config/web-config";
import { getDefaultLang, isSupportedLocale, SUPPORTED_LOCALES } from "@/utils/tool";
function createRouter(i18n: any) {
  return _createRouter(i18n, {
    version: 4,
    defaultLocale: getDefaultLang(),
    strategy: "no_prefix",
    locales: [...SUPPORTED_LOCALES],
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: setupLayouts([
      ...routes,
      {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: () => import("@/pages/404.vue"),
      },
    ]),
  });
}
const router = createRouter(i18n);
router.isReady().then(() => {
  loadingFadeOut();
});
router.beforeEach(
  (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    const requestedLocale = Array.isArray(to.query.lang) ? to.query.lang[0] : to.query.lang;
    if (isSupportedLocale(requestedLocale)) {
      i18n.global.locale.value = requestedLocale;
      Cookies.set(I18N_COOKIE_KEY, requestedLocale);

      const queryWithoutLocale = { ...to.query };
      delete queryWithoutLocale.lang;

      if (to.path === "/") {
        next({
          path: "/login",
          query: queryWithoutLocale,
        });
      } else if (to.query.lang !== undefined) {
        // 清空lang参数做重定向
        next({
          path: to.path,
          query: queryWithoutLocale,
          hash: to.hash,
          replace: true,
        });
      } else {
        next();
      }
      return;
    }

    if (to.path === "/") {
      next({
        path: "/login",
        query: to.query,
      });
    } else {
      next();
    }
    // if (to.path ==='/' || to.path === `/${i18n.global.locale.value}` || to.path === `/${i18n.global.locale.value}/`) {
    //   const newPath =  `/${i18n.global.locale.value}/login`
    //   next({
    //     path:newPath,
    //     query:to.query,
    //   });
    //   return
    // }
    // const locales = ["en", "es"];
    // const pathHasLocale = locales.some(
    //   (locale) => to.path === `/${locale}` || to.path.startsWith(`/${locale}/`)
    // );
    // if (!pathHasLocale) {
    //   const newPath = `/${i18n.global.locale.value}${to.path === "/" ? "" : to.path}`;
    //   next({
    //     path: newPath,
    //     query:to.query,
    //   });
    // } else {
    //   next();
    // }
  }
);

if (import.meta.hot) {
  handleHotUpdate(router);
}
export default router;
